
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import MonetizationOnSharpIcon from '@mui/icons-material/MonetizationOnSharp';
import '../../Css/footMenu.css';
import RodapeFim from './RodapeFoot';

function FooterMenu() {

  const navigate=useNavigate()


  return (
    <footer className="footer">
      {/* BACK TO TOP */}
      <div className="footer-top" onClick={() => window.scrollTo(0, 0)}>
        Back to Top
      </div>

      {/* LINKS */}
      <div className="footer-links">
        <div>
          <h4>Get to Know Us</h4>
          <ul>
            <li>Careers</li>
            <li>Blog</li>
            <li>
              <Link to="/aboutUs">About Tou Aki</Link>
            </li>
            <li>Investor Relations</li>
            <li>Tou Aki Devices</li>
          </ul>
        </div>

        <div>
          <h4>Make Money with Us</h4>
          <ul>
            <li onClick={(e)=>navigate('https://touaki-supplier.web.app')}>Sell on Tou Aki</li>
            <li>
              <Link to="/New/Ambassador">Become Ambassador</Link>
            </li>
            <li>Affiliate Program</li>
            <li>Advertise Products</li>
          </ul>
        </div>

        <div>
          <h4>Payment Products</h4>
          <ul>
            <li>Tou Aki Business Card</li>
            <li onClick={(e)=>alert('vas poder fazer compras co pontos na Tou Aki')}>Shop with Points</li>
            <li onClick={(e)=>alert('Envia Dinheiro para Paises atraves da Tou Aki Exchange')}>Send Money</li>
          </ul>
        </div>

        <div>
          <h4>Help</h4>
          <ul>
            <li onClick={(e)=>navigate('/User/Painel')} >Your Account</li>
            <li onClick={(e)=>navigate('/User/Orders')} >Your Orders</li>
            <li>Returns</li>
            <li>Shipping</li>
            <li>Support</li>
          </ul>
        </div>
      </div>

      {/* SETTINGS */}
      <div className="footer-settings">
        <div className="brand">
          <span>Tou<span>Aki</span></span>
        </div>

        <div className="settings">
          <div>
            <LanguageSharpIcon />
            <select>
              <option>Português</option>
              <option>English</option>
            </select>
          </div>

          <div>
            <MonetizationOnSharpIcon />
            <select>
              <option>KZ</option>
              <option>USD</option>
              <option>£</option>
            </select>
          </div>

          <div className="country">
            <img
              src="https://cdn.countryflags.com/thumbs/angola/flag-400.png"
              alt="Angola"
            />
            <span>Angola</span>
          </div>
        </div>
      </div>

      {/* SERVICES GRID */}
      <div className="footer-services">
        {[
          'Toca Aki',
          'Sell on Tou Aki',
          'Taxi Na Placa',
          'Tou Aki Advertising',
          'Tou Aki Drive',
          'Navideo Direct',
          'SearchCamp',
          'Binary School',
          'NoCubico',
          'GoodReader',
        ].map((service, i) => (
          <div key={i} className="service">
            {service}
          </div>
        ))}
      </div>

      {/* FOOTER END */}
      <RodapeFim />
    </footer>
  );
}

export default FooterMenu;
